

/****************************************************************************

  Generated by const.tst - please don't make any changes in this file

****************************************************************************/


    /** Generated from NBWebCGA.Web.ClientApp.Security.PermissionConstants **/
	export const PermissionConstants = { 
		applicationAccess: 'ApplicationAccess',
    
    WorkflowCreationPage: {
    
		accessPage: 'WorkflowCreationPage.AccessPage',
    },
    WorkflowSearchPage: {
    
		accessPage: 'WorkflowSearchPage.AccessPage',
    },
    WorkflowEditPage: {
    
		accessPage: 'WorkflowEditPage.AccessPage',
		deleteData: 'WorkflowEditPage.DeleteData',
		editData: 'WorkflowEditPage.EditData',
		editSubscriberData: 'WorkflowEditPage.EditSubscriberData',
		saveData: 'WorkflowEditPage.SaveData',
		sendData: 'WorkflowEditPage.SendData',
		submitData: 'WorkflowEditPage.SubmitData',
		returnData: 'WorkflowEditPage.ReturnData',
    },
	}


